import * as React from 'react';
import ToastContext from './ToastContext';

export default () => React.useContext(ToastContext);
